import { render, staticRenderFns } from "./NoLoginRegisterRes.vue?vue&type=template&id=66a6bd16&scoped=true&"
import script from "./NoLoginRegisterRes.vue?vue&type=script&lang=js&"
export * from "./NoLoginRegisterRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a6bd16",
  null
  
)

export default component.exports